import { render, staticRenderFns } from "./bindTaoBaoShop.vue?vue&type=template&id=fc0d6dae&"
import script from "./bindTaoBaoShop.vue?vue&type=script&lang=js&"
export * from "./bindTaoBaoShop.vue?vue&type=script&lang=js&"
import style0 from "./bindTaoBaoShop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports